export default "__VITE_ASSET__ecL1n5zn__"